import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import isEqual from 'lodash/isEqual';
import {getScrollingElement} from '~/utils/scrolling';
//
import {actions, select} from './connectors';
import Complements from '~/components/Complements';

const propTypes = {
  alternatives: PropTypes.arrayOf(
    PropTypes.shape({
      alternativeId: PropTypes.string,
      style: PropTypes.object
    })
  ),
  anchorStyle: PropTypes.object,
  checkScroll: PropTypes.bool,
  complements: PropTypes.arrayOf(
    PropTypes.shape({
      complementId: PropTypes.string,
      style: PropTypes.object
    })
  ),
  complementsLoaded: PropTypes.bool,
  hasCompatibleStyles: PropTypes.bool,
  hasComplements: PropTypes.bool,
  icons: PropTypes.array,
  inSkirt: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isFundraisingMode: PropTypes.bool,
  isSelectedProductMask: PropTypes.bool,
  limitComplementCount: PropTypes.bool,
  loadAnchorCompatibleStyles: PropTypes.func,
  loadAnchorComplements: PropTypes.func,
  meta: PropTypes.objectOf(PropTypes.func),
  selectedProduct: PropTypes.object,
  selectedProductColor: PropTypes.object,
  selectedProducts: PropTypes.array,
  selectedProductType: PropTypes.string,
  showAnchorStyle: PropTypes.bool,
  showOrderMore: PropTypes.bool,
  onClickOrderMore: PropTypes.func,
  onPickProduct: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export class ComplementsWrapper extends Component {
  static propTypes = propTypes;

  static defaultProps = {
    isFundraisingMode: false,
    limitComplementCount: false,
    showOrderMore: true,
    onClickOrderMore: () => {}
  };

  state = {
    hasScrolled: false
  };

  componentDidMount() {
    if (this.props.checkScroll) {
      window.addEventListener('scroll', this.handleScroll);
    } else {
      this.setState({hasScrolled: true});
    }
    if (this.props.complements) {
      this.loadComplements();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.complements, this.props.complements)) {
      if (nextProps.complements.length > 0) {
        this.loadComplements(nextProps);
      } else {
        this.props.loadAnchorComplements();
        this.props.loadAnchorCompatibleStyles();
      }
    }
    if (!isEqual(nextProps.alternatives, this.props.alternatives)) {
      if (nextProps.alternatives.length > 0) {
        this.loadComplements(nextProps);
      } else {
        this.props.loadAnchorComplements();
      }
    }
  }

  componentDidUpdate(proveProps, prevState) {
    if (prevState.isDisabled && !this.state.isDisabled) {
      getScrollingElement().scrollTop = this.state.scrollPosition;
    }
  }

  handleScroll = () => {
    const scrollPosition =
      document.body.scrollTop || document.documentElement.scrollTop;
    scrollPosition > 20 && this.triggerScrollRender();
  };

  triggerScrollRender = () => {
    this.setState({hasScrolled: true});
    window.removeEventListener('scroll', this.handleScroll);
  };

  loadComplements(props = this.props) {
    const unloadedComplementsStyles = props.complements
      .filter(complement => !complement.style)
      .map(complement => complement.complementId);
    const unloadedAlternativeStyles = props.alternatives
      .filter(alternative => !alternative.style)
      .map(alternative => alternative.alternativeId);
    const unloadedStyles = unloadedComplementsStyles.concat(
      unloadedAlternativeStyles
    );
    if (unloadedStyles.length > 0) {
      props.loadStyles(unloadedStyles);
    }
  }

  render() {
    const {
      anchorStyle,
      hasComplements,
      hasCompatibleStyles,
      isSelectedProductMask
    } = this.props;
    const {hasScrolled} = this.state;
    const showComplements =
      (hasComplements || hasCompatibleStyles) &&
      anchorStyle &&
      !anchorStyle.specialty &&
      hasScrolled &&
      !this.props.isDisabled;
    const props = {...this.props, showOrderMore: !isSelectedProductMask};

    return showComplements ? <Complements {...props} /> : null;
  }
}

export default connect(select, actions)(ComplementsWrapper);
